import { Breadcrumb } from "../../../../core/Breadcrumb.js";
import { Text } from "../../../../core/Text.js";
import { ActionButton } from "../../../shared/ActionButton.js";
import { useChromeHints } from "../../../shared/chromeHints.js";
import type { ForgeMineHeadingContent } from "../../forgeContent.js";

/** The creator's page top: where it sits, its h1, what it is, and Create. Phones get Back. */
export function ForgeMineHeading({
  trail,
  current,
  title,
  intro,
  back,
  action,
}: ForgeMineHeadingContent) {
  useChromeHints({ back });
  return (
    <div className="flex flex-col gap-4 md:gap-5">
      <Breadcrumb items={[...trail, { label: current }]} className="max-md:hidden" />
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div className="flex max-w-2xl flex-col gap-2">
          <Text as="h1" variant="display-xl2" tone="primary" className="max-md:text-display-xl3">
            {title}
          </Text>
          <Text variant="body-b1" tone="secondary">
            {intro}
          </Text>
        </div>
        <ActionButton action={action} variant="primary" className="max-md:w-full" />
      </div>
    </div>
  );
}
